import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.sass';

//Dependencies
import superagent from 'superagent';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import Alert from '../Alert';

//Custom
//import deptosArray from './ProductForm/deptos.js';
//import subDeptosArray from './ProductForm/subdeptos.js';
//import deptosArrayMX from './ProductForm/deptosMX.js';
//import subDeptosArrayMX from './ProductForm/subdeptosMX.js';

//const deptosArr = (process.env.REACT_APP_COUNTRY === 'MX' && deptosArrayMX) || deptosArray;
// const subDeptosArr = (process.env.REACT_APP_COUNTRY === 'MX' && subDeptosArrayMX) || subDeptosArray;

const Product = (props) => {
  const { webserviceURL, setSectionName, setOptionSelected } = props;
  const [productList, setProductList] = useState([]);
  const [deptoSelected, setDeptoSelected] = useState('1');
  const [loading, setLoading] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);

  const [categorias, setCategorias] = useState([]);

  const deleteProduct = (product) => {
    setLoading(true);
    let question = window.confirm('¿Eliminar producto? Esta acción no se puede deshacer');
    if (question) {
      const url = `${webserviceURL}/postDescripciones`;

      superagent
        .post(url)
        .set('Content-Type', 'application/json')
        .send({
          ...product,
          accion: 'BORRAR',
        })
        .then((res) => {
          if (res.body) {
            const { mensaje } = res.body;
            window.scrollTo(0, 0);
            setAlertText(mensaje);
            // getProducts();
          } else {
            setAlertText('Ocurró un error, vuelva a intentarlo');
          }
          setOpen(true);
        })
        .catch((err) => {
          console.log(err);
          setAlertText('Ocurró un error');
          setOpen(true);
        });
    } else {
      setLoading(false);
    }
  };

  // Estas categorias son las mismas que tiene el carrito
  const getCategorias = useCallback(() => {
    const urlCategorias = `${webserviceURL}/getCatalogoProductos`;
    superagent
      .get(urlCategorias)
      .set('Content-Type', 'application/json')
      .auth(localStorage.getItem('TMBtoken'), { type: 'bearer' })
      .then((res) => {
        if (res.body) {
          setCategorias(res.body.categorias);
        } else {
          setAlertText('Ocurró un error al cargar las categorias, vuelva a intentarlo');
          setOpen(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setAlertText('Ocurró un error al cargar las categorias');
        setOpen(true);
      });
  }, [webserviceURL]);

  const verProductos = (codigo) => {
    setLoading(true);
    setProductList([]);
    setDeptoSelected(codigo);
    const categoriaSeleccionada = categorias.find((item) => item.Codigo === codigo);
    setProductList(
      categoriaSeleccionada?.subCategorias.flatMap((sub) =>
        sub.productos.map((producto) => ({
          ...producto,
          codigoSubCategoria: sub.Codigo,
          subCategoria: sub.Descripcion1,
        })),
      ),
    );
    setLoading(false);
  };

  useEffect(() => {
    //getProducts();
    setSectionName('Productos');
    setOptionSelected('products');
    getCategorias();
  }, [setSectionName, setOptionSelected, getCategorias]);

  useEffect(() => {
    if (!categorias.length) return;

    verProductos('1000');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categorias]);

  return (
    <div className={styles.productListContainer}>
      <Alert open={open} setOpen={setOpen} title='Mensaje del sistema' text={alertText} />
      <div className={styles.buttonNewProduct}>
        <Link to={`editproduct/newproduct`}>
          <Button
            type='button'
            variant='contained'
            size='large'
            color='primary'
            className={`${styles.button}`}>
            Nuevo producto
          </Button>
        </Link>
      </div>
      <div className={styles.tabs}>
        {categorias.map((val, key) => {
          return (
            <div className={styles.tab} key={key}>
              <div
                className={`${styles.tabContent} ${styles[deptoSelected === val.Codigo]}`}
                onClick={() => verProductos(val.Codigo)}>
                {val.Descripcion1}
              </div>
            </div>
          );
        })}
      </div>
      {loading && (
        <div className={styles.loading}>
          <CircularProgress />
        </div>
      )}
      {productList?.length > 0 && (
        <div className={styles.productList}>
          <div className={`${styles.productRow} ${styles.header}`}>
            <div className={`${styles.headerColumn} ${styles.imageProduct}`}>Imagen</div>
            <div className={`${styles.headerColumn}`}>Clave</div>
            <div className={`${styles.headerColumn}`}>Nombre</div>
            <div className={`${styles.headerColumn}`}>Departamento</div>
            <div className={`${styles.headerActions}`}>Acciones</div>
          </div>
          {productList.map((val, key) => {
            const rowType = key % 2;
            const { Codigo, Descripcion1, subCategoria } = val;

            // const subdepto =
            //   (subDeptosArr[parseInt(deptoSelected) - 1] &&
            //     subDeptosArr[parseInt(deptoSelected) - 1][parseInt(subdepartamento) - 1] &&
            //     subDeptosArr[parseInt(deptoSelected) - 1][parseInt(subdepartamento) - 1].label) ||
            //   '';

            return (
              <div className={`${styles.productRow} ${styles[rowType]}`} key={key}>
                <div className={`${styles.productColumn} ${styles.imageProduct}`}>
                  <img
                    src={`https://webimages.terramarbrands.com.mx/images-usa/shopping-cart/cart-products/${Codigo}.jpg`}
                    alt=''
                  />
                </div>
                <div className={`${styles.productColumn}`}>{Codigo}</div>
                <div className={`${styles.productColumn}`}>{Descripcion1}</div>
                <div className={`${styles.productColumn}`}>{subCategoria}</div>
                <div className={styles.actions}>
                  <div className={`${styles.action} ${styles.edit}`}>
                    <Link to={`editproduct/${Codigo}`} className={styles.edit}>
                      <i className='material-icons'>edit</i>
                    </Link>
                  </div>
                  <div
                    className={`${styles.action} ${styles.delete}`}
                    onClick={() => deleteProduct(val)}>
                    <i className='material-icons'>delete</i>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Product;
